import React, { useState } from 'react'
import ModalCustom from '../../../components/modal-custom'
import ActionImportExcel from '../../../components/income-dif/ActionImportExcel'
import SwalCustomSuccess from '../../../alert/swal-success'
import Error_false from '../../../components/error/error-false'
import { importIncomeLoanHomeAPI } from '../../../services/income/loan-home'
import ExcelApps from '../template/load-home.xlsx'
import ButtonDownloadExcel from '../../../components/income-dif/ButtonDownloadExcel'
export default function ModalImportFile({
  orgId,
  open,
  onCancel,
  fnGetData,
  data
}) {
  const [isSubmit, setIsSubmit] = useState(false)

  const handleSubmit = async (d) => {
    setIsSubmit(true)
    const body = {
      orgId,
      loanHomeList: d.map((l) => ({
        period: l.date,
        loanAcc: l['Account'] + '',
        amounts: l['Amount']
      }))
    }

    const resp = await importIncomeLoanHomeAPI(body)
    setIsSubmit(false)
    if (!resp) return
    if (resp.status) {
      SwalCustomSuccess().then(() => {
        onCancel()
        fnGetData()
      })
    } else {
      Error_false(resp)
    }
  }

  return (
    <ModalCustom
      maskClosable={false} // ป้องกันการปิดเมื่อคลิกที่ mask (backdrop)
      keyboard={false} // ป้องกันการปิดเมื่อกดปุ่ม Esc
      open={open}
      onCancel={onCancel}
    >
      <div>
        <h5>{data ? 'Update' : 'Add'} Import</h5>
        <ButtonDownloadExcel
          fileName="template-loan-home"
          ExcelApps={ExcelApps}
        />

        <ActionImportExcel isSave={isSubmit} handleSubmit={handleSubmit} />
      </div>
    </ModalCustom>
  )
}
